module.exports = __webpack_public_path__ + "./fonts/KarmilaScript-JRJ4j.otf";